// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2yh1l","title":"ClientInsurance_title__2kc19","itemText":"ClientInsurance_itemText__3BQ01"};